import { siteUrl } from '@/shared/utils/siteUrl'

export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE || 'es-CO'
export const homeLink = siteUrl + '/'
export const isArgen =
  LOCALE === 'es-AR' || LOCALE === 'es-PY' || LOCALE === 'es-UY'
export const nosotrasurl =
  {
    'es-CL': 'nosotrasonline.cl',
  }[LOCALE] || 'nosotrasonline.com.' + LOCALE.split('-')[1].toLowerCase()

export const concourseId = ({
  'es-CO': { DEV: 594, PDN: 718 },
  'es-PE': { DEV: 603, PDN: 732 },
  'es-AR': { DEV: 604, PDN: 733 },
  'es-CL': { DEV: 605, PDN: 735 },
  'es-PR': { DEV: 606, PDN: -1 },
  'es-DO': { DEV: 607, PDN: 738 },
  'es-EC': { DEV: 608, PDN: 736 },
}[LOCALE] || { DEV: 2, PDN: 2 })[ENV]

export const gameId = ({
  'es-CO': { DEV: 233, PDN: 240 },
  'es-PE': { DEV: 242, PDN: 249 },
  'es-AR': { DEV: 243, PDN: 250 },
  'es-CL': { DEV: 244, PDN: 251 },
  'es-PR': { DEV: 245, PDN: -1 },
  'es-DO': { DEV: 246, PDN: 254 },
  'es-EC': { DEV: 247, PDN: 252 },
}[LOCALE] || { DEV: 2, PDN: 2 })[ENV]

export const costActivity = 20
export const costHelpActivity = 10
export const activity_dates = ['xx-01-xxxx', 'xx-01-xxxx']
export const topNumber =
  {
    'es-CO': 50,
    'es-PE': 20,
    'es-AR': 5,
    'es-PR': 5,
    'es-EC': 20,
    'es-DO': 10,
  }[LOCALE] || 10
export const HAVE_TOP = !['es-AR', 'es-UY'].includes(LOCALE)
export const NO_REDIME = ['es-BO', 'es-UY'].includes(LOCALE)
export const SHOW_STORE_PACKAGE_MESSAGE = !['es-BO', 'es-CL', 'es-UY'].includes(
  LOCALE
)
export const LOCALE_AT = {
  COLOMBIA: LOCALE === 'es-CO',
  ARGENTINA: LOCALE === 'es-AR',

  BOLIVIA: LOCALE === 'es-BO',

  ECUADOR: LOCALE === 'es-EC',

  PERU: LOCALE === 'es-PE',

  CHILE: LOCALE === 'es-CL',
  URUGUAY: LOCALE === 'es-UY',

  DOMINICANA: LOCALE === 'es-DO',
  PUERTO_RICO: LOCALE === 'es-PR',
  PARAGUAY: LOCALE === 'es-PY',
}
export const pointsForVideoWatched = 10
